import { useSelector } from 'react-redux';

const selectCurrentBusiness = ({ business }) => business?.currentBusiness;

// POS promotions are only available to businesses that have the feature enabled
// in their business metadata.
const usePromotionsEnabled = () => {
  const currentBusiness = useSelector(selectCurrentBusiness);

  return currentBusiness?.metadata?.promotionInfo?.enabled === true;
};

export default usePromotionsEnabled;
